import React from 'react'
import { Form, Input } from 'antd'
import { RadioButtonF } from '@/i2antdV5'

const FormItem = Form.Item
class CardServiceAlertsForm extends React.Component {
  render() {
    const { form } = this.props
    return (
      <div>CardServiceAlertsForm</div>
    )
  }
}
export default CardServiceAlertsForm